module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pages-common-treatments"
  }, [(_vm.loading) ? _c('Loader') : _vm._e(), _c('Header'), (_vm.props) ? _c('div', {
    staticClass: "inner-page"
  }, [_c('div', {
    staticClass: "subnav"
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/common-treatments"
    }
  }, [_vm._v("Common Treatments")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/types-of-braces"
    }
  }, [_vm._v("Types of Braces")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/surgical-orthodontics"
    }
  }, [_vm._v("Surgical Orthodontics")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/tads"
    }
  }, [_vm._v("TADs")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/acceledent-aura"
    }
  }, [_vm._v("AcceleDent® Aura")])], 1)])]), _c('div', {
    staticClass: "main-content"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "left-area"
  }, [_c('H1', {
    staticClass: "title",
    domProps: {
      "innerHTML": _vm._s(_vm.props.title.rendered)
    }
  }), _vm._l((_vm.props.acf.common_orthodontic), function(common) {
    return (_vm.props) ? _c('div', {
      staticClass: "before-after-box"
    }, [_c('h2', {
      domProps: {
        "innerHTML": _vm._s(common.treatment_title)
      }
    }), _c('div', {
      staticClass: "before-after-img"
    }, [_c('figure', [_c('img', {
      attrs: {
        "src": common.before_image,
        "alt": "before photo"
      }
    }), _c('figcaption', [_vm._v("Before")])]), _c('figure', [_c('img', {
      attrs: {
        "src": common.after_image,
        "alt": "after photo"
      }
    }), _c('figcaption', [_vm._v("After")])])]), _c('div', {
      staticClass: "before-after-text",
      domProps: {
        "innerHTML": _vm._s(common.treatment_desc)
      }
    })]) : _vm._e()
  })], 2)])])]) : _vm._e(), _c('Footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-eadd937a","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/pages/common-treatments/common-treatments.pug
// module id = 1307
// module chunks = 1